import { getData } from "../apiClient";

// Get all menu data from API
export const getAllMenus = async () => {
    try {
        const result = await getData('/role/veryfication/getall/');
        return {
            data: {
                success: true,
                ...result
            }
        };
    } catch (error) {
        console.error('Get all menus API error:', error);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};
